import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useInvoices} from '../hooks/useInvoices';

export const ReloadRecordsButton = () => {

    const {fetchRecords} = useInvoices();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};